import { PivotBasePlainObject } from './pivotBase.plainObject';
import { ColumnPlainObject } from './column.plainObject';

export class UnpivotPlainObject extends PivotBasePlainObject {
    public unpivotKeyColumn: ColumnPlainObject;
    public unpivotedColumns: ColumnPlainObject[] = [];
    public lateralColumnArrangement: boolean = true;
    public dropNullRows: boolean;
}
